import React from "react";
import { Outlet, NavLink, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { LogOut, LayoutGrid, BookOpen, ImageIcon, Loader2, Award } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[var(--pc-bg)] flex items-center justify-center">
        <Loader2 className="text-[var(--pc-bronze)] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  const navItem = ({ isActive }) =>
    `flex items-center gap-3 px-5 py-3 border-l-2 transition-colors duration-300 ${
      isActive
        ? "border-[var(--pc-bronze)] text-[var(--pc-text)] bg-[#101013]"
        : "border-transparent text-[var(--pc-text-soft)] hover:text-[var(--pc-text)] hover:bg-[#0e0e11]"
    }`;

  const itemStyle = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: "0.22em",
    textTransform: "uppercase",
  };

  const doLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[var(--pc-bg)] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-[240px] shrink-0 bg-[#08080a] border-r border-[var(--pc-line)] flex flex-col">
        <div className="p-7">
          <div
            className="text-[var(--pc-bronze)]"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: 10,
              letterSpacing: "0.34em",
              textTransform: "uppercase",
            }}
          >
            Panel
          </div>
          <div
            className="mt-2 text-[var(--pc-text)]"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 300,
              fontSize: 15,
              letterSpacing: "0.16em",
            }}
          >
            Paco Cabrera
          </div>
        </div>

        <nav className="mt-4 flex-1">
          <NavLink to="/admin" end className={navItem} style={itemStyle} data-testid="nav-dashboard">
            <LayoutGrid size={14} strokeWidth={1.4} />
            Inicio
          </NavLink>
          <NavLink to="/admin/proyectos" className={navItem} style={itemStyle} data-testid="nav-projects">
            <ImageIcon size={14} strokeWidth={1.4} />
            Proyectos
          </NavLink>
          <NavLink to="/admin/cuaderno" className={navItem} style={itemStyle} data-testid="nav-journal">
            <BookOpen size={14} strokeWidth={1.4} />
            Cuaderno
          </NavLink>
          <NavLink to="/admin/aliados" className={navItem} style={itemStyle} data-testid="nav-allies">
            <Award size={14} strokeWidth={1.4} />
            Aliados
          </NavLink>
        </nav>

        <div className="p-5 border-t border-[var(--pc-line)]">
          <div
            className="text-[var(--pc-text-soft)] mb-3 truncate"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 300, fontSize: 11, letterSpacing: "0.18em" }}
          >
            {user.email}
          </div>
          <button
            onClick={doLogout}
            data-testid="logout-btn"
            className="flex items-center gap-2 text-[var(--pc-text-soft)] hover:text-[var(--pc-bronze-bright)] transition-colors"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: 11,
              letterSpacing: "0.28em",
              textTransform: "uppercase",
            }}
          >
            <LogOut size={13} strokeWidth={1.4} />
            Salir
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
